import React from 'react'

export const nebraskaSetupVars = {
  siteId: 'nebraska',
  pathPrefix: '/ne',
  menuHeader: "Discover Nebraska's Solution for:",
  appUrl: 'https://ne.headed2.com',
  logoImg: '/images/assets/nebraska/horizontal/dark.svg',
  headerTitle: `The Nebraska CareerExplorer is a system designed for Nebraska`
}
